import styled from 'styled-components'
import { BLACK, BLUE, GRAYSCALE_500, LIGHT_YELLOW, PALE_YELLOW } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div<{ $isValid: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ $isValid }) => $isValid ? 'transparent' : LIGHT_YELLOW};
  border: ${({ $isValid }) => $isValid ? 'none' : `1px solid ${PALE_YELLOW}`};
  padding: ${({ $isValid }) => $isValid ? 0 : '16px 12px'};
  border-radius: ${({ $isValid }) => $isValid ? 0 : '8px'};
  gap: 16px;
  cursor: pointer;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ItemRow = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-family: ${INTER.regular};
  font-size: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const LeftSection = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconContainer = (styled.div`
  width: 48px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const Icon = (styled.img`
  width: 52px;
  height: 32px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const MultiLineInfoContainer = (styled.div`
  display: flex;
  flex-direction: column;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const SingleLineInfoContainer = (styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const NameText = (styled.span`
  color: ${BLACK};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const NicknameText = (styled.span`
  color: ${BLUE};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ProviderText = (styled.span`
  color: ${GRAYSCALE_500};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
